import { useEffect } from "react";
import { Form, FormItemProps, FormRule, Input, InputProps } from "antd";
import { NamePath, StoreValue } from "antd/es/form/interface";
import { translate } from "../../translate";

const trimmed = (value: StoreValue) =>
  typeof value === "string" ? value.trim() : value;

export const emailFormatRule = (): FormRule => ({
  type: "email",
  transform: trimmed,
  message: translate("email_invalid_message"),
});

export const EmailFormItem = ({
  name,
  inputProps,
  ...itemProps
}: EmailFormItemProps) => {
  const form = Form.useFormInstance();
  const value = Form.useWatch(name, form);

  useEffect(() => {
    if (!form.getFieldError(name).length) return;

    form.validateFields([name]).catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Form.Item
      {...itemProps}
      name={name}
      rules={[emailFormatRule()]}
      validateTrigger="onBlur"
      normalize={trimmed}
    >
      <Input {...inputProps} />
    </Form.Item>
  );
};

interface EmailFormItemProps
  extends Omit<
    FormItemProps,
    "name" | "rules" | "children" | "validateTrigger" | "normalize"
  > {
  name: NamePath;
  inputProps?: InputProps;
}
